import * as React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { JSX } from "react";
import useCurrentResourceCentre from "../hooks/useCurrentResourceCentre";
import { RootState } from "../store";
import { isAdmin } from "./NavigationBar/SideBar";

interface Props {
  component?: React.ComponentType;
  [key: string]: any;
}

const EnsureUser = ({ component: Component, ...rest }: Props): JSX.Element => {
  const user = useSelector((state: RootState) => state.userContext.userCreds);
  const mode = useSelector((state: RootState) => state.userContext.mode);
  const rc = useCurrentResourceCentre();
  const isOkhatiAdmin = isAdmin(mode);

  return user && Component && (isOkhatiAdmin || rc) ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Component {...rest} />
  ) : (
    <Box component="div" sx={{ textAlign: "center", width: "100%" }}>
      <CircularProgress />
    </Box>
  );
};

export default EnsureUser;
